import React from 'react';
import { connect } from 'react-redux';

import Start from '../../pages/Start';
import Question from '../../pages/Question';
import Result from '../../pages/Result';
import Finish from '../../pages/Finish';

import './styles.scss';


class Layout extends React.Component {

    componentDidUpdate(prevProps) {
      if (prevProps.page !== this.props.page) {
        window.scrollTo({ top: 0, left: 0 });
      }
    }

  render() {
        let classLayout = '';

        if (this.props.page > 0 && this.props.page < 7) {
          classLayout = '-question' + this.props.page;
        }

        return (
          <div className={`layout ${classLayout}`}>
          	<div className="layout__content">

              { this.props.page === 0 &&
                <Start />
              }

              { this.props.page === 1 &&
                <Question number={this.props.page} result={this.props.result} />
              }

              { this.props.page === 2 &&
                <Question number={this.props.page} result={this.props.result} />
              }

              { this.props.page === 3 &&
                <Question number={this.props.page} result={this.props.result} />
              }

              { this.props.page === 4 &&
                <Question number={this.props.page} result={this.props.result} />
              }

              { this.props.page === 5 &&
                <Question number={this.props.page} result={this.props.result} />
              }

              { this.props.page === 6 &&
                <Question number={this.props.page} result={this.props.result} />
              }

              { this.props.page === 7 &&
                <Result result={this.props.result} />
              }

              { this.props.page === 8 &&
                <Finish />
              }

          	</div>
          	<div className="layout__footer">&copy;&nbsp;Mail.ru Group</div>
          </div>
        )
    }
}

const mapStateToProps = function(store) {
  return {
    page: store.pagesState.current,
    result: store.pagesState.result,
  };
};

export default connect(mapStateToProps)(Layout);
